import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TPostGenerateCompanyOnboardingShareableLinkRequest } from "./postGenerateCompanyOnboardingShareableLink.schema";

export const postGenerateCompanyOnboardingShareableLink = (
  axios: IAxiosInstance
) => {
  return async (body: TPostGenerateCompanyOnboardingShareableLinkRequest) => {
    const response = await axios.noRetry.post<ZealApiResponse<string>>(
      "/api/generate-company-onboarding-link",
      body
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
